import { getMockMode, getMockResponse } from '~/utils/maintenanceMock';
import { BaseRestRepository } from './baseRestRepository';
import type { ClientVersionInfoDto } from '~/swagger/portal/Api';

const VERSIONS_URL = '/api/public/versions';

export interface VersionCheckResult {
  versions: ClientVersionInfoDto[];
  success: boolean;
  error?: Error;
}

export class VersionRepository extends BaseRestRepository {
  public async getLatestVersion(platform: 'web' | 'mobile'): Promise<ClientVersionInfoDto[]> {
    const mockMode = getMockMode();
    if (mockMode) {
      console.warn(`🔧 Using mock data: ${mockMode}`);
      return getMockResponse();
    }

    const url = `${VERSIONS_URL}/${platform}`;
    const response = await this.fetchWithoutAuth(url);
    return this.getJsonResponse(response);
  }

  public async getLatestVersionSafe(platform: 'web' | 'mobile'): Promise<VersionCheckResult> {
    try {
      const versions = await this.getLatestVersion(platform);
      return {
        versions,
        success: true,
      };
    } catch (error) {
      console.error('Version check failed:', error);
      return {
        versions: [],
        success: false,
        error: error instanceof Error ? error : new Error('Unknown error'),
      };
    }
  }
}

export const versionRepository = new VersionRepository();
